import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { UpdateData } from 'src/app/models/commos/update-data';
import { Plan } from 'src/app/models/configuration/plan';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, LocalStorageService, MenuBreadCrumb, MessageService, params, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.scss'],
    standalone: false
})
export class PlansComponent implements OnInit {

  public urlGetPlanes: string = `${EndpointDictionary.Plans.PLANS_TABLE}`;
  private urlPlan: string = `${EndpointDictionary.Plans.CRUD_PLANS}`;
  public params: Array<params> = []

  public columnasPlanes: TableColumns<Plan>[] = [
    {
      ID: 'name',
      label: 'nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },

    },
    {
      ID: 'equipmentsNumber',
      label: '# equipos',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'numberUsers',
      label: '# Usuarios',
      type: 'number',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
    {
      ID: 'basePrice',
      label: 'precio Base',
      type: 'number',
      style: {
        textAlign: 'center',

      },
    },
    {
      ID: 'priceItem',
      label: 'precio Item',
      type: 'number',
      style: {
        textAlign: 'center',

      },
    },
    {
      ID: 'currency',
      label: 'moneda',
      type: 'text',
      style: {
        textAlign: 'center',

      },
    }
  ]


  public recargarTablaPlanes = new EventEmitter<any>()
  public configurationPlanes: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable:true,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
  }

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Planes",
    current:true
  }]

  constructor(
    private http: HttpService,
    private router: Router,
    private message: MessageService,
    private deleteUser: DeleteGenericService,
    private storage : LocalStorageService
  ) {
    let rol: string = this.storage.get<string>('rol');
    if (rol != 'root') {
      sessionStorage.clear();
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {

  }


  async agregarPlan($event: Plan){
    let plan : Plan = $event
    plan.isActive = 1
    this.message.openLoading('Cargando', 'Creando PLan')
    let res:GenericResponse = await this.http.postDataBody(this.urlPlan, plan)
    if(res){
      this.message.SuccessToast('PLan creado correctamente')
      this.recargarTablaPlanes.emit()
    }
    this.message.closeLoading()
  }

  async editarPlan($event: UpdateData<Plan>){
    let plan : Plan = $event.new
    plan.id = $event.old.id
    plan.isActive = 1
    this.message.openLoading('Cargando', 'Actualizando PLan')
    let res:GenericResponse = await this.http.putDataBody(this.urlPlan, plan)
    if(res){
      this.message.SuccessToast('Plan actualizado correctamente')
      this.recargarTablaPlanes.emit()
    }
    this.message.closeLoading()
  }

 async eliminarPlanes($event: Plan[]) {
   let res =  await this.deleteUser.deleteD($event, this.urlPlan, "id", "Plane", "Planes")
   this.recargarTablaPlanes.emit()
 }

 seleccionadosPlanes($event) {
    ////console.log($event)
  }

  clickFilaPlan($event) {

  }

}
